import { Chatroom } from '../../models';

import AddChatroomButton from './AddChatroomButton';
import ViewCreatorsButton from './ViewCreatorsButton';
import ChatroomItem from './ChatroomItem';
import ReactModal from 'react-modal';
import { useOpenActivateConfirmModal } from './UseOpenActivateConfirmModal';
import { ActivateConfirmModal } from './ActivateConfirmModal';
import { useContext } from 'react';
import LIFFUserContext from '../../contexts/LIFFUserContext';
import { CustomerProfile } from '../../models/customerProfile';
import { ActivityStatus } from '../../models/ActivityStatus';
import { useOpenQuickActionConfirmModal } from './UseOpenQuickActionConfirmModal';
import { QuickActionConfirmModal } from './QuickActionConfirmModal';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../../models/userRole';

export default function ChatroomList({ rooms }: { rooms: Chatroom[] }) {
  const [t] = useTranslation(['chatroom']);
  const customerProfile = useContext(LIFFUserContext) as CustomerProfile;
  const onGoing: Chatroom[] = [];
  const onGoingOwned: Chatroom[] = [];
  const notActivated: Chatroom[] = [];
  const closed: Chatroom[] = [];
  const [activateConfirmState, setActivateConfirmModalState] =
    useOpenActivateConfirmModal();
  const [quickActionModalState, setQuickActionModalState] =
    useOpenQuickActionConfirmModal();
  const warpedModalToggle = (room: Chatroom) => {
    return () => {
      setActivateConfirmModalState(true, room);
    };
  };

  rooms.forEach((room) => {
    const { activity } = room;

    switch (activity.status) {
      case ActivityStatus.ACTIVATE:
        room.role === UserRole.OWNER
          ? onGoingOwned.push(room)
          : onGoing.push(room);
        break;
      case ActivityStatus.NEW:
        notActivated.push(room);
        break;
      case ActivityStatus.INACTIVATE:
        closed.push(room);
        break;
      default:
        break;
    }
  });

  // Ensure onGoingOwned remains unaltered, while adding into onGoing with corret time-sorted order.
  onGoingOwned
    .slice()
    .reverse()
    .forEach((room: Chatroom) => {
      onGoing.unshift(room);
    });

  return (
    <>
      {customerProfile.isABO && (
        <div className="w-full flex flex-row justify-evenly gap-4 px-4 mt-8">
          <div className="w-1/2 self-center">
            <AddChatroomButton />
          </div>
          <div className="w-1/2 self-center">
            <ViewCreatorsButton />
          </div>
        </div>
      )}
      <div className="flex flex-col px-5 w-full gap-4 my-8">
        {onGoing.length > 0 ? (
          <span className="font-medium">
            {t('ongoing_activity', '進行中的活動（{{count}}）', {
              count: onGoing.length,
            })}
          </span>
        ) : (
          <></>
        )}
        {onGoing.map((room) => (
          <ChatroomItem
            key={room.id}
            room={room}
            onOpenQuickDialog={setQuickActionModalState}
          />
        ))}

        {notActivated.length > 0 ? (
          <span className="font-medium">
            {t('not_activated_activity', '尚未開始的活動（{{count}}）', {
              count: notActivated.length,
            })}
          </span>
        ) : (
          <></>
        )}
        {notActivated.map((room) => (
          <ChatroomItem
            key={room.id}
            room={room}
            onOpenQuickDialog={setQuickActionModalState}
            startActivity={warpedModalToggle(room)}
          />
        ))}

        {closed.length > 0 ? (
          <span className="font-medium">
            {t('closed_activity', '已結束的活動（{{count}}）', {
              count: closed.length,
            })}
          </span>
        ) : (
          <></>
        )}
        {closed.map((room) => (
          <ChatroomItem
            key={room.id}
            room={room}
            onOpenQuickDialog={setQuickActionModalState}
          />
        ))}
      </div>

      <ReactModal
        isOpen={activateConfirmState.isOpen}
        overlayClassName="z-[51] fixed bg-black/[.4] inset-0 backdrop-blur-sm"
        className="flex h-full w-full justify-center items-center px-5"
      >
        <ActivateConfirmModal
          room={activateConfirmState.room!}
          toggleModal={setActivateConfirmModalState}
        ></ActivateConfirmModal>
      </ReactModal>

      <ReactModal
        isOpen={quickActionModalState.isOpen}
        overlayClassName="z-[51] fixed bg-black/[.4] inset-0 backdrop-blur-sm"
        className="flex h-full w-full justify-center items-center px-5"
      >
        <QuickActionConfirmModal
          room={quickActionModalState.room!}
          action={quickActionModalState.action!}
          toggleModal={setQuickActionModalState}
        />
      </ReactModal>
    </>
  );
}
